import type { Maybe } from "@regle/core"
import { withMessage } from "@regle/rules"
import type { Moment } from "moment"
import type { RecurringAvailability } from "@/models/recurring-availability.model.ts"

export { chronologicalStartAndEndTimeValidator } from "@/helper/validation/time-validation.ts"

/**
 * Validates that a time value (timeStart or timeEnd) is present.
 */
export const startAndEndTimeRequiredValidator = withMessage(
  (value: Maybe<Moment>): boolean => !!value,
  "De start- en eindtijd zijn verplicht."
)

/**
 * Validates that a recurring availability does not overlap with any sibling slots
 * of the same availability type on the same day.
 * Overlap between AVAILABLE and UNAVAILABLE slots is allowed (e.g. "available all day
 * except 12:00–13:00").
 */
export function timeNoOverlapValidator(
  sibilingRecurringAvailabilities: RecurringAvailability[],
  source?: RecurringAvailability
) {
  return withMessage(
    (ra: Maybe<Pick<RecurringAvailability, "timeStart" | "timeEnd" | "availabilityType">>) => {
      if (!ra?.timeStart || !ra.timeEnd) {
        return true
      }

      const { timeStart, timeEnd } = ra

      return !sibilingRecurringAvailabilities.some((other) => {
        if (
          other === (source ?? ra) ||
          !other.timeStart ||
          !other.timeEnd ||
          other.availabilityType !== ra.availabilityType
        ) {
          return false
        }
        return timeStart.isBefore(other.timeEnd) && timeEnd.isAfter(other.timeStart)
      })
    },
    "Tijdsloten mogen elkaar niet overlappen."
  )
}
